/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Filters {
  "use strict";

  angular.module("meevo.components.filters", []);
}